import styles from './Styles.module.scss'
import {CrossIcon} from "../assets/Icons";

function CloseButton({onClick, style}) {
    return (<div onClick={onClick} className={styles.closeButton} style={style}>
        <CrossIcon/>
    </div>);
}

export default CloseButton